
          import p from "/build/web/src/app/public/logos/white/goalert-logo-white-scaled@2.png"
          const prefixPath = pathPrefix + "/static/" + p
          export default prefixPath
        